import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from 'components/ui/login/msalInstance';
import { RouterProvider } from 'react-router-dom';
import { router } from 'router';

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <div className='si-main'>
        <RouterProvider router={router} />
      </div>
    </MsalProvider>
  );
}

export default App;
